/**
 * Cookie に値をセットします。valが空文字の場合、Cookieを削除します。
 *
 * @param {string} key - セットするCookieのキー。
 * @param {string} val - セットするCookieの値。空文字の場合、Cookieを削除します。
 * @param {number} [days] - Cookieの有効期間（日数）。指定しない場合、セッションCookieとして設定します。
 */
export function setCookie(key, val, days) {
    if (val === '') {
        // valが空文字の場合、Cookieを削除
        const expires = new Date(0); // 過去の日時
        document.cookie = `${encodeURIComponent(key)}=; expires=${expires.toUTCString()}`;
        return;
    }

    let cookie = `${encodeURIComponent(key)}=${encodeURIComponent(val)}`;
    if (days != null) {
        const expires = new Date();
        expires.setDate(expires.getDate() + days);
        cookie += `;expires=${expires.toUTCString()}`;
    }
    document.cookie = cookie;
}
